import NewsList from "./NewsList.vue.js";
import _sfc_main$1 from "../../Base/BanzaFiltersButton.vue.js";
import FilterChip from "../../Base/FilterChip.vue.js";
import Layout from "../../../constants/Layout.js";
import { NEWS_TAGS } from "../../../graphql/news.js";
import "../../../plugins/apollo.js";
import "lodash-es";
import "moment";
import { resolveComponent, createElementBlock, openBlock, createElementVNode, createCommentVNode, createVNode, createBlock, toDisplayString, Fragment, renderList } from "vue";
import "../../../constants/UserPolicy.js";
import "pinia";
import "../../../store/index.js";
import "../../../plugins/i18n.js";
import "../../../assets/e94e4817134d7c25.png";
import "../../../assets/5341da3ffbec0137.png";
import "../../../assets/01f50022317dccd7.png";
import "axios";
import "vue-router";
import "maska";
import { useLocalePath } from "../../../composables/useLocalePath.js";
import "../../../graphql/queries.js";
import "../../../graphql/subscriptions.js";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../../constants/components/index.js";
/* empty css                            */
import "vuetify/components/VDialog";
import "../../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                           */
import _export_sfc from "../../../_virtual/_plugin-vue_export-helper.js";
import "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                     */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../../assets/8a32dc557a826bf0.png";
/* empty css                        */
import "../../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                    */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../../Auth/AppleAuthButton/AppleAuthButton.js";
import "../../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../../Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                                  */
import { VSpacer } from "vuetify/components/VGrid";
import "../../Base/index.js";
import "vuex";
/* empty css                           */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../../icons/mdi/index.js";
/* empty css                               */
import "vuetify/components/VBtnToggle";
import "../../../assets/6f5dc1ff0a697731.svg";
import "../../../assets/888bb8db73be3c15.svg";
/* empty css                                */
import "vuetify/components/VInfiniteScroll";
/* empty css                                     */
/* empty css                             */
import "../../HtmlEditor/index.js";
import "../../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                                  */
/* empty css                           */
/* empty css                           */
import "../../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                    */
import "vuetify/components/VWindow";
import "../../../assets/5a0af7dd23957928.png";
import "../../../graphql/system-settings.js";
import "tiny-emitter/instance";
/* empty css                                */
/* empty css                               */
import "vuetify/components/VHover";
import "../../../constants/NewsGroup.js";
/* empty css                                */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                      */
import "vuetify/components/VBottomSheet";
import "../../../graphql/favorites.js";
import "../../../plugins/tracker/page-tracker.js";
/* empty css                        */
import "vuetify/components/VChip";
import "../../../graphql/notifications.js";
/* empty css                                     */
import "../../../constants/CommunicationChannels.js";
/* empty css                               */
import "vuetify/components/VColorPicker";
/* empty css                                                   */
import "vuetify/components/VTextarea";
/* empty css                                                */
/* empty css                             */
import "graphql-tag";
import "../../../graphql/entity.js";
import "../../../graphql/lookups.js";
/* empty css                          */
import "vuetify/components";
/* empty css                                */
/* empty css                        */
import "../../../graphql/system-events.js";
/* empty css                                           */
/* empty css                            */
import "vuetify/components/VTooltip";
/* empty css                            */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../../graphql/files.js";
/* empty css                               */
import "vuetify/components/VForm";
/* empty css                                    */
/* empty css                                                  */
import "vuetify/components/VAlert";
/* empty css                                       */
import "vue-dndrop";
/* empty css                                               */
/* empty css                                       */
import "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
/* empty css                           */
import "vuetify/components/VFileInput";
/* empty css                               */
import "vuetify/components/VAvatar";
/* empty css                                     */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                                 */
import "../../../graphql/public-articles.js";
/* empty css                                              */
/* empty css                                  */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                     */
import "vuetify/components/VItemGroup";
/* empty css                                */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                           */
import "../../../graphql/quartz.js";
import "vue-i18n";
import "../../../graphql/integration-systems.js";
import "../../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                         */
/* empty css                                       */
import "../../../graphql/session-store.js";
import "../../../composables/useModalPage.js";
import "../../../icons/portal/index.js";
const _sfc_main = {
  name: "NewsModule",
  components: {
    NewsList,
    BanzaFiltersButton: _sfc_main$1,
    FilterChip
  },
  props: {
    layout: {
      type: Number,
      default: Layout.Rows
    },
    useTopBlock: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const localePath = useLocalePath();
    return {
      localePath
    };
  },
  data() {
    return {
      serverFilters: null,
      initialFiltersModel: {},
      filterFields: [
        {
          key: "entity.title",
          type: "text",
          attrs: {
            label: this.$t("pages.news.edit.title")
          }
        },
        {
          key: "entity.tags.some.id",
          type: "lookup",
          operation: "in",
          attrs: {
            "name": "id",
            "label": this.$t("pages.news.edit.tags"),
            "query": NEWS_TAGS,
            "search-operation": "contains_ci",
            "multiple": true
          }
        }
      ]
    };
  },
  head() {
    const title = this.$t("meta.news_title");
    const description = this.$t("meta.news_description");
    return {
      title,
      meta: [
        { hid: "og:title", property: "og:title", content: title },
        {
          hid: "description",
          name: "description",
          content: description
        },
        {
          hid: "og:description",
          property: "og:description",
          content: description
        },
        {
          hid: "twitter:title",
          property: "twitter:title",
          content: title
        },
        {
          hid: "twitter:description",
          property: "twitter:description",
          content: description
        }
      ]
    };
  },
  computed: {
    filterTags() {
      var _a;
      return ((_a = this.initialFiltersModel) == null ? void 0 : _a["entity.tags.some.id"]) || [];
    }
  },
  created() {
    const query = Object.assign({}, this.$route.query);
    if (query.tagId) {
      const tag = { id: query.tagId, name: query.tagName };
      delete query.tagId;
      delete query.tagName;
      this.$router.replace({ query: null });
      this.initialFiltersModel["entity.tags.some.id"] = [tag];
    }
  },
  methods: {
    addFilterTag(tag) {
      var _a;
      if (!tag || this.filterTags.find((t) => t.id === tag.id)) {
        return;
      }
      if (!((_a = this.initialFiltersModel) == null ? void 0 : _a["entity.tags.some.id"])) {
        this.initialFiltersModel["entity.tags.some.id"] = [tag];
      } else {
        this.initialFiltersModel["entity.tags.some.id"].push(tag);
      }
      this.$refs.filterButton.applyFilters(this.initialFiltersModel);
    },
    deleteFilterTag(tag) {
      var _a;
      this.initialFiltersModel["entity.tags.some.id"] = this.filterTags.filter((f) => f.id !== tag.id) || [];
      if (!((_a = this.initialFiltersModel["entity.tags.some.id"]) == null ? void 0 : _a.length)) {
        delete this.initialFiltersModel["entity.tags.some.id"];
      }
      this.$refs.filterButton.applyFilters(this.initialFiltersModel);
    },
    reload() {
      this.$refs.newsList.reloadData();
    },
    addNews() {
      this.$router.push(this.localePath("/news/add/new"));
    }
  }
};
const _hoisted_1 = {
  class: "mx-auto pa-6 news-section",
  style: { "max-width": "1400px" }
};
const _hoisted_2 = { class: "d-flex align-center flex-nowrap mb-6 g-2" };
const _hoisted_3 = { class: "banza-header" };
const _hoisted_4 = {
  key: 0,
  class: "d-flex flex-wrap g-2 mb-2"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  const _component_b_btn = resolveComponent("b-btn");
  const _component_BanzaFiltersButton = resolveComponent("BanzaFiltersButton");
  const _component_FilterChip = resolveComponent("FilterChip");
  const _component_news_list = resolveComponent("news-list");
  return openBlock(), createElementBlock("div", _hoisted_1, [
    createElementVNode("div", _hoisted_2, [
      createElementVNode("span", _hoisted_3, toDisplayString(_ctx.$t("news.module_caption")), 1),
      createVNode(VSpacer),
      _ctx.$auth.hasPolicy(_ctx.$auth.userPolicy.NewsEditor.code) ? (openBlock(), createBlock(_component_b_btn, {
        key: 0,
        preset: "add",
        text: _ctx.$t("pages.news.index.add"),
        onClick: $options.addNews
      }, null, 8, ["text", "onClick"])) : createCommentVNode("", true),
      ((_a = $data.filterFields) == null ? void 0 : _a.length) ? (openBlock(), createBlock(_component_BanzaFiltersButton, {
        key: 1,
        ref: "filterButton",
        modelValue: $data.serverFilters,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.serverFilters = $event),
        initialFiltersModel: $data.initialFiltersModel,
        "onUpdate:initialFiltersModel": _cache[1] || (_cache[1] = ($event) => $data.initialFiltersModel = $event),
        "filter-fields": $data.filterFields
      }, null, 8, ["modelValue", "initialFiltersModel", "filter-fields"])) : createCommentVNode("", true),
      createVNode(_component_b_btn, {
        preset: "moduleReload",
        onClick: $options.reload
      }, null, 8, ["onClick"])
    ]),
    $options.filterTags.length ? (openBlock(), createElementBlock("div", _hoisted_4, [
      (openBlock(true), createElementBlock(Fragment, null, renderList($options.filterTags, (tag) => {
        return openBlock(), createBlock(_component_FilterChip, {
          key: tag.id,
          label: _ctx.$t("base.labels.tag"),
          "string-filters": tag.name,
          onClear: ($event) => $options.deleteFilterTag(tag)
        }, null, 8, ["label", "string-filters", "onClear"]);
      }), 128))
    ])) : createCommentVNode("", true),
    createVNode(_component_news_list, {
      ref: "newsList",
      "from-module": "",
      "use-top-block": $props.useTopBlock,
      layout: $props.layout,
      where: $data.serverFilters,
      onTagClick: $options.addFilterTag
    }, null, 8, ["use-top-block", "layout", "where", "onTagClick"])
  ]);
}
const NewsModule = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  NewsModule as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTmV3c01vZHVsZS52dWUuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL05ld3MvTmV3c01vZHVsZS9OZXdzTW9kdWxlLnZ1ZSJdLCJzb3VyY2VzQ29udGVudCI6WyI8dGVtcGxhdGU+XG5cdDxkaXZcblx0XHRjbGFzcz1cIm14LWF1dG8gcGEtNiBuZXdzLXNlY3Rpb25cIlxuXHRcdHN0eWxlPVwibWF4LXdpZHRoOiAxNDAwcHhcIj5cblx0XHQ8ZGl2IGNsYXNzPVwiZC1mbGV4IGFsaWduLWNlbnRlciBmbGV4LW5vd3JhcCBtYi02IGctMlwiPlxuXHRcdFx0PHNwYW4gY2xhc3M9XCJiYW56YS1oZWFkZXJcIj57eyAkdChcIm5ld3MubW9kdWxlX2NhcHRpb25cIikgfX08L3NwYW4+XG5cdFx0XHQ8di1zcGFjZXIgLz5cblx0XHRcdDxiLWJ0blxuXHRcdFx0XHR2LWlmPVwiJGF1dGguaGFzUG9saWN5KCRhdXRoLnVzZXJQb2xpY3kuTmV3c0VkaXRvci5jb2RlKVwiXG5cdFx0XHRcdHByZXNldD1cImFkZFwiXG5cdFx0XHRcdDp0ZXh0PVwiJHQoJ3BhZ2VzLm5ld3MuaW5kZXguYWRkJylcIlxuXHRcdFx0XHRAY2xpY2s9XCJhZGROZXdzXCIgLz5cblx0XHRcdDxCYW56YUZpbHRlcnNCdXR0b25cblx0XHRcdFx0di1pZj1cImZpbHRlckZpZWxkcz8ubGVuZ3RoXCJcblx0XHRcdFx0cmVmPVwiZmlsdGVyQnV0dG9uXCJcblx0XHRcdFx0di1tb2RlbD1cInNlcnZlckZpbHRlcnNcIlxuXHRcdFx0XHR2LW1vZGVsOmluaXRpYWxGaWx0ZXJzTW9kZWw9XCJpbml0aWFsRmlsdGVyc01vZGVsXCJcblx0XHRcdFx0OmZpbHRlci1maWVsZHM9XCJmaWx0ZXJGaWVsZHNcIiAvPlxuXHRcdFx0PGItYnRuXG5cdFx0XHRcdHByZXNldD1cIm1vZHVsZVJlbG9hZFwiXG5cdFx0XHRcdEBjbGljaz1cInJlbG9hZFwiIC8+XG5cdFx0PC9kaXY+XG5cdFx0PGRpdlxuXHRcdFx0di1pZj1cImZpbHRlclRhZ3MubGVuZ3RoXCJcblx0XHRcdGNsYXNzPVwiZC1mbGV4IGZsZXgtd3JhcCBnLTIgbWItMlwiPlxuXHRcdFx0PEZpbHRlckNoaXBcblx0XHRcdFx0di1mb3I9XCJ0YWcgaW4gZmlsdGVyVGFnc1wiXG5cdFx0XHRcdDprZXk9XCJ0YWcuaWRcIlxuXHRcdFx0XHQ6bGFiZWw9XCIkdCgnYmFzZS5sYWJlbHMudGFnJylcIlxuXHRcdFx0XHQ6c3RyaW5nLWZpbHRlcnM9XCJ0YWcubmFtZVwiXG5cdFx0XHRcdEBjbGVhcj1cImRlbGV0ZUZpbHRlclRhZyh0YWcpXCIgLz5cblx0XHQ8L2Rpdj5cblx0XHQ8bmV3cy1saXN0XG5cdFx0XHRyZWY9XCJuZXdzTGlzdFwiXG5cdFx0XHRmcm9tLW1vZHVsZVxuXHRcdFx0OnVzZS10b3AtYmxvY2s9XCJ1c2VUb3BCbG9ja1wiXG5cdFx0XHQ6bGF5b3V0PVwibGF5b3V0XCJcblx0XHRcdDp3aGVyZT1cInNlcnZlckZpbHRlcnNcIlxuXHRcdFx0QHRhZ0NsaWNrPVwiYWRkRmlsdGVyVGFnXCIgLz5cblx0PC9kaXY+XG48L3RlbXBsYXRlPlxuPHNjcmlwdD5cbmltcG9ydCBOZXdzTGlzdCBmcm9tIFwiLi9OZXdzTGlzdC52dWVcIjtcbmltcG9ydCBCYW56YUZpbHRlcnNCdXR0b24gZnJvbSBcIkAvY29tcG9uZW50cy9CYXNlL0JhbnphRmlsdGVyc0J1dHRvbi52dWVcIjtcbmltcG9ydCBGaWx0ZXJDaGlwIGZyb20gXCJAL2NvbXBvbmVudHMvQmFzZS9GaWx0ZXJDaGlwLnZ1ZVwiO1xuXG5pbXBvcnQgTGF5b3V0IGZyb20gXCJAL2NvbnN0YW50cy9MYXlvdXRcIjtcblxuaW1wb3J0IHsgTkVXU19UQUdTIH0gZnJvbSBcIkAvZ3JhcGhxbC9uZXdzXCI7XG5cbmltcG9ydCB7IHVzZUxvY2FsZVBhdGggfSBmcm9tIFwiQC9jb21wb3NhYmxlc1wiO1xuXG5leHBvcnQgZGVmYXVsdCB7XG5cdG5hbWU6IFwiTmV3c01vZHVsZVwiLFxuXHRjb21wb25lbnRzOiB7XG5cdFx0TmV3c0xpc3QsXG5cdFx0QmFuemFGaWx0ZXJzQnV0dG9uLFxuXHRcdEZpbHRlckNoaXAsXG5cdH0sXG5cdHByb3BzOiB7XG5cdFx0bGF5b3V0OiB7XG5cdFx0XHR0eXBlOiBOdW1iZXIsXG5cdFx0XHRkZWZhdWx0OiBMYXlvdXQuUm93cyxcblx0XHR9LFxuXHRcdHVzZVRvcEJsb2NrOiB7XG5cdFx0XHR0eXBlOiBCb29sZWFuLFxuXHRcdFx0ZGVmYXVsdDogdHJ1ZSxcblx0XHR9LFxuXHR9LFxuXHRzZXR1cCgpIHtcblx0XHRjb25zdCBsb2NhbGVQYXRoID0gdXNlTG9jYWxlUGF0aCgpO1xuXHRcdHJldHVybiB7XG5cdFx0XHRsb2NhbGVQYXRoLFxuXHRcdH07XG5cdH0sXG5cdGRhdGEoKSB7XG5cdFx0cmV0dXJuIHtcblx0XHRcdHNlcnZlckZpbHRlcnM6IG51bGwsXG5cdFx0XHRpbml0aWFsRmlsdGVyc01vZGVsOiB7fSxcblx0XHRcdGZpbHRlckZpZWxkczogW1xuXHRcdFx0XHR7XG5cdFx0XHRcdFx0a2V5OiBcImVudGl0eS50aXRsZVwiLFxuXHRcdFx0XHRcdHR5cGU6IFwidGV4dFwiLFxuXHRcdFx0XHRcdGF0dHJzOiB7XG5cdFx0XHRcdFx0XHRsYWJlbDogdGhpcy4kdChcInBhZ2VzLm5ld3MuZWRpdC50aXRsZVwiKSxcblx0XHRcdFx0XHR9LFxuXHRcdFx0XHR9LFxuXHRcdFx0XHR7XG5cdFx0XHRcdFx0a2V5OiBcImVudGl0eS50YWdzLnNvbWUuaWRcIixcblx0XHRcdFx0XHR0eXBlOiBcImxvb2t1cFwiLFxuXHRcdFx0XHRcdG9wZXJhdGlvbjogXCJpblwiLFxuXHRcdFx0XHRcdGF0dHJzOiB7XG5cdFx0XHRcdFx0XHRcIm5hbWVcIjogXCJpZFwiLFxuXHRcdFx0XHRcdFx0XCJsYWJlbFwiOiB0aGlzLiR0KFwicGFnZXMubmV3cy5lZGl0LnRhZ3NcIiksXG5cdFx0XHRcdFx0XHRcInF1ZXJ5XCI6IE5FV1NfVEFHUyxcblx0XHRcdFx0XHRcdFwic2VhcmNoLW9wZXJhdGlvblwiOiBcImNvbnRhaW5zX2NpXCIsXG5cdFx0XHRcdFx0XHRcIm11bHRpcGxlXCI6IHRydWUsXG5cdFx0XHRcdFx0fSxcblx0XHRcdFx0fSxcblx0XHRcdF0sXG5cdFx0fTtcblx0fSxcblx0aGVhZCgpIHtcblx0XHRjb25zdCB0aXRsZSA9IHRoaXMuJHQoXCJtZXRhLm5ld3NfdGl0bGVcIik7XG5cdFx0Y29uc3QgZGVzY3JpcHRpb24gPSB0aGlzLiR0KFwibWV0YS5uZXdzX2Rlc2NyaXB0aW9uXCIpO1xuXHRcdHJldHVybiB7XG5cdFx0XHR0aXRsZTogdGl0bGUsXG5cdFx0XHRtZXRhOiBbXG5cdFx0XHRcdHsgaGlkOiBcIm9nOnRpdGxlXCIsIHByb3BlcnR5OiBcIm9nOnRpdGxlXCIsIGNvbnRlbnQ6IHRpdGxlIH0sXG5cdFx0XHRcdHtcblx0XHRcdFx0XHRoaWQ6IFwiZGVzY3JpcHRpb25cIixcblx0XHRcdFx0XHRuYW1lOiBcImRlc2NyaXB0aW9uXCIsXG5cdFx0XHRcdFx0Y29udGVudDogZGVzY3JpcHRpb24sXG5cdFx0XHRcdH0sXG5cdFx0XHRcdHtcblx0XHRcdFx0XHRoaWQ6IFwib2c6ZGVzY3JpcHRpb25cIixcblx0XHRcdFx0XHRwcm9wZXJ0eTogXCJvZzpkZXNjcmlwdGlvblwiLFxuXHRcdFx0XHRcdGNvbnRlbnQ6IGRlc2NyaXB0aW9uLFxuXHRcdFx0XHR9LFxuXHRcdFx0XHR7XG5cdFx0XHRcdFx0aGlkOiBcInR3aXR0ZXI6dGl0bGVcIixcblx0XHRcdFx0XHRwcm9wZXJ0eTogXCJ0d2l0dGVyOnRpdGxlXCIsXG5cdFx0XHRcdFx0Y29udGVudDogdGl0bGUsXG5cdFx0XHRcdH0sXG5cdFx0XHRcdHtcblx0XHRcdFx0XHRoaWQ6IFwidHdpdHRlcjpkZXNjcmlwdGlvblwiLFxuXHRcdFx0XHRcdHByb3BlcnR5OiBcInR3aXR0ZXI6ZGVzY3JpcHRpb25cIixcblx0XHRcdFx0XHRjb250ZW50OiBkZXNjcmlwdGlvbixcblx0XHRcdFx0fSxcblx0XHRcdF0sXG5cdFx0fTtcblx0fSxcblx0Y29tcHV0ZWQ6IHtcblx0XHRmaWx0ZXJUYWdzKCkge1xuXHRcdFx0cmV0dXJuIHRoaXMuaW5pdGlhbEZpbHRlcnNNb2RlbD8uW1wiZW50aXR5LnRhZ3Muc29tZS5pZFwiXSB8fCBbXTtcblx0XHR9LFxuXHR9LFxuXHRjcmVhdGVkKCkge1xuXHRcdGNvbnN0IHF1ZXJ5ID0gT2JqZWN0LmFzc2lnbih7fSwgdGhpcy4kcm91dGUucXVlcnkpO1xuXHRcdGlmIChxdWVyeS50YWdJZCkge1xuXHRcdFx0Y29uc3QgdGFnID0geyBpZDogcXVlcnkudGFnSWQsIG5hbWU6IHF1ZXJ5LnRhZ05hbWUgfTtcblx0XHRcdGRlbGV0ZSBxdWVyeS50YWdJZDtcblx0XHRcdGRlbGV0ZSBxdWVyeS50YWdOYW1lO1xuXHRcdFx0dGhpcy4kcm91dGVyLnJlcGxhY2UoeyBxdWVyeTogbnVsbCB9KTtcblx0XHRcdHRoaXMuaW5pdGlhbEZpbHRlcnNNb2RlbFtcImVudGl0eS50YWdzLnNvbWUuaWRcIl0gPSBbdGFnXTtcblx0XHR9XG5cdH0sXG5cdG1ldGhvZHM6IHtcblx0XHRhZGRGaWx0ZXJUYWcodGFnKSB7XG5cdFx0XHRpZiAoIXRhZyB8fCB0aGlzLmZpbHRlclRhZ3MuZmluZCgodCkgPT4gdC5pZCA9PT0gdGFnLmlkKSkge1xuXHRcdFx0XHRyZXR1cm47XG5cdFx0XHR9XG5cdFx0XHRpZiAoIXRoaXMuaW5pdGlhbEZpbHRlcnNNb2RlbD8uW1wiZW50aXR5LnRhZ3Muc29tZS5pZFwiXSkge1xuXHRcdFx0XHR0aGlzLmluaXRpYWxGaWx0ZXJzTW9kZWxbXCJlbnRpdHkudGFncy5zb21lLmlkXCJdID0gW3RhZ107XG5cdFx0XHR9IGVsc2Uge1xuXHRcdFx0XHR0aGlzLmluaXRpYWxGaWx0ZXJzTW9kZWxbXCJlbnRpdHkudGFncy5zb21lLmlkXCJdLnB1c2godGFnKTtcblx0XHRcdH1cblx0XHRcdHRoaXMuJHJlZnMuZmlsdGVyQnV0dG9uLmFwcGx5RmlsdGVycyh0aGlzLmluaXRpYWxGaWx0ZXJzTW9kZWwpO1xuXHRcdH0sXG5cdFx0ZGVsZXRlRmlsdGVyVGFnKHRhZykge1xuXHRcdFx0dGhpcy5pbml0aWFsRmlsdGVyc01vZGVsW1wiZW50aXR5LnRhZ3Muc29tZS5pZFwiXSA9XG5cdFx0XHRcdHRoaXMuZmlsdGVyVGFncy5maWx0ZXIoKGYpID0+IGYuaWQgIT09IHRhZy5pZCkgfHwgW107XG5cdFx0XHRpZiAoIXRoaXMuaW5pdGlhbEZpbHRlcnNNb2RlbFtcImVudGl0eS50YWdzLnNvbWUuaWRcIl0/Lmxlbmd0aCkge1xuXHRcdFx0XHRkZWxldGUgdGhpcy5pbml0aWFsRmlsdGVyc01vZGVsW1wiZW50aXR5LnRhZ3Muc29tZS5pZFwiXTtcblx0XHRcdH1cblx0XHRcdHRoaXMuJHJlZnMuZmlsdGVyQnV0dG9uLmFwcGx5RmlsdGVycyh0aGlzLmluaXRpYWxGaWx0ZXJzTW9kZWwpO1xuXHRcdH0sXG5cdFx0cmVsb2FkKCkge1xuXHRcdFx0dGhpcy4kcmVmcy5uZXdzTGlzdC5yZWxvYWREYXRhKCk7XG5cdFx0fSxcblx0XHRhZGROZXdzKCkge1xuXHRcdFx0dGhpcy4kcm91dGVyLnB1c2godGhpcy5sb2NhbGVQYXRoKFwiL25ld3MvYWRkL25ld1wiKSk7XG5cdFx0fSxcblx0fSxcbn07XG48L3NjcmlwdD5cblxuPHN0eWxlIGxhbmc9XCJzY3NzXCI+PC9zdHlsZT5cbiJdLCJuYW1lcyI6WyJCYW56YUZpbHRlcnNCdXR0b24iLCJfb3BlbkJsb2NrIiwiX2NyZWF0ZUVsZW1lbnRCbG9jayIsIl9jcmVhdGVFbGVtZW50Vk5vZGUiLCJfdG9EaXNwbGF5U3RyaW5nIiwiX2NyZWF0ZVZOb2RlIiwiX2NvbXBvbmVudF92X3NwYWNlciIsIl9jcmVhdGVCbG9jayIsIl9GcmFnbWVudCIsIl9yZW5kZXJMaXN0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBb0RBLE1BQUssWUFBVTtBQUFBLEVBQ2QsTUFBTTtBQUFBLEVBQ04sWUFBWTtBQUFBLElBQ1g7QUFBQSxJQUNBLG9CQUFBQTtBQUFBQSxJQUNBO0FBQUEsRUFDQTtBQUFBLEVBQ0QsT0FBTztBQUFBLElBQ04sUUFBUTtBQUFBLE1BQ1AsTUFBTTtBQUFBLE1BQ04sU0FBUyxPQUFPO0FBQUEsSUFDaEI7QUFBQSxJQUNELGFBQWE7QUFBQSxNQUNaLE1BQU07QUFBQSxNQUNOLFNBQVM7QUFBQSxJQUNUO0FBQUEsRUFDRDtBQUFBLEVBQ0QsUUFBUTtBQUNQLFVBQU0sYUFBYSxjQUFlO0FBQ2xDLFdBQU87QUFBQSxNQUNOO0FBQUEsSUFDQTtBQUFBLEVBQ0Q7QUFBQSxFQUNELE9BQU87QUFDTixXQUFPO0FBQUEsTUFDTixlQUFlO0FBQUEsTUFDZixxQkFBcUIsQ0FBRTtBQUFBLE1BQ3ZCLGNBQWM7QUFBQSxRQUNiO0FBQUEsVUFDQyxLQUFLO0FBQUEsVUFDTCxNQUFNO0FBQUEsVUFDTixPQUFPO0FBQUEsWUFDTixPQUFPLEtBQUssR0FBRyx1QkFBdUI7QUFBQSxVQUN0QztBQUFBLFFBQ0Q7QUFBQSxRQUNEO0FBQUEsVUFDQyxLQUFLO0FBQUEsVUFDTCxNQUFNO0FBQUEsVUFDTixXQUFXO0FBQUEsVUFDWCxPQUFPO0FBQUEsWUFDTixRQUFRO0FBQUEsWUFDUixTQUFTLEtBQUssR0FBRyxzQkFBc0I7QUFBQSxZQUN2QyxTQUFTO0FBQUEsWUFDVCxvQkFBb0I7QUFBQSxZQUNwQixZQUFZO0FBQUEsVUFDWjtBQUFBLFFBQ0Q7QUFBQSxNQUNEO0FBQUEsSUFDRDtBQUFBLEVBQ0Q7QUFBQSxFQUNELE9BQU87QUFDTixVQUFNLFFBQVEsS0FBSyxHQUFHLGlCQUFpQjtBQUN2QyxVQUFNLGNBQWMsS0FBSyxHQUFHLHVCQUF1QjtBQUNuRCxXQUFPO0FBQUEsTUFDTjtBQUFBLE1BQ0EsTUFBTTtBQUFBLFFBQ0wsRUFBRSxLQUFLLFlBQVksVUFBVSxZQUFZLFNBQVMsTUFBTztBQUFBLFFBQ3pEO0FBQUEsVUFDQyxLQUFLO0FBQUEsVUFDTCxNQUFNO0FBQUEsVUFDTixTQUFTO0FBQUEsUUFDVDtBQUFBLFFBQ0Q7QUFBQSxVQUNDLEtBQUs7QUFBQSxVQUNMLFVBQVU7QUFBQSxVQUNWLFNBQVM7QUFBQSxRQUNUO0FBQUEsUUFDRDtBQUFBLFVBQ0MsS0FBSztBQUFBLFVBQ0wsVUFBVTtBQUFBLFVBQ1YsU0FBUztBQUFBLFFBQ1Q7QUFBQSxRQUNEO0FBQUEsVUFDQyxLQUFLO0FBQUEsVUFDTCxVQUFVO0FBQUEsVUFDVixTQUFTO0FBQUEsUUFDVDtBQUFBLE1BQ0Q7QUFBQSxJQUNEO0FBQUEsRUFDRDtBQUFBLEVBQ0QsVUFBVTtBQUFBLElBQ1QsYUFBYTs7QUFDWixlQUFPLFVBQUssd0JBQUwsbUJBQTJCLDJCQUEwQixDQUFFO0FBQUEsSUFDOUQ7QUFBQSxFQUNEO0FBQUEsRUFDRCxVQUFVO0FBQ1QsVUFBTSxRQUFRLE9BQU8sT0FBTyxDQUFFLEdBQUUsS0FBSyxPQUFPLEtBQUs7QUFDakQsUUFBSSxNQUFNLE9BQU87QUFDaEIsWUFBTSxNQUFNLEVBQUUsSUFBSSxNQUFNLE9BQU8sTUFBTSxNQUFNLFFBQVM7QUFDcEQsYUFBTyxNQUFNO0FBQ2IsYUFBTyxNQUFNO0FBQ2IsV0FBSyxRQUFRLFFBQVEsRUFBRSxPQUFPLEtBQUcsQ0FBRztBQUNwQyxXQUFLLG9CQUFvQixxQkFBcUIsSUFBSSxDQUFDLEdBQUc7QUFBQSxJQUN2RDtBQUFBLEVBQ0E7QUFBQSxFQUNELFNBQVM7QUFBQSxJQUNSLGFBQWEsS0FBSzs7QUFDakIsVUFBSSxDQUFDLE9BQU8sS0FBSyxXQUFXLEtBQUssQ0FBQyxNQUFNLEVBQUUsT0FBTyxJQUFJLEVBQUUsR0FBRztBQUN6RDtBQUFBLE1BQ0Q7QUFDQSxVQUFJLEdBQUMsVUFBSyx3QkFBTCxtQkFBMkIseUJBQXdCO0FBQ3ZELGFBQUssb0JBQW9CLHFCQUFxQixJQUFJLENBQUMsR0FBRztBQUFBLGFBQ2hEO0FBQ04sYUFBSyxvQkFBb0IscUJBQXFCLEVBQUUsS0FBSyxHQUFHO0FBQUEsTUFDekQ7QUFDQSxXQUFLLE1BQU0sYUFBYSxhQUFhLEtBQUssbUJBQW1CO0FBQUEsSUFDN0Q7QUFBQSxJQUNELGdCQUFnQixLQUFLOztBQUNwQixXQUFLLG9CQUFvQixxQkFBcUIsSUFDN0MsS0FBSyxXQUFXLE9BQU8sQ0FBQyxNQUFNLEVBQUUsT0FBTyxJQUFJLEVBQUUsS0FBSyxDQUFFO0FBQ3JELFVBQUksR0FBQyxVQUFLLG9CQUFvQixxQkFBcUIsTUFBOUMsbUJBQWlELFNBQVE7QUFDN0QsZUFBTyxLQUFLLG9CQUFvQixxQkFBcUI7QUFBQSxNQUN0RDtBQUNBLFdBQUssTUFBTSxhQUFhLGFBQWEsS0FBSyxtQkFBbUI7QUFBQSxJQUM3RDtBQUFBLElBQ0QsU0FBUztBQUNSLFdBQUssTUFBTSxTQUFTLFdBQVk7QUFBQSxJQUNoQztBQUFBLElBQ0QsVUFBVTtBQUNULFdBQUssUUFBUSxLQUFLLEtBQUssV0FBVyxlQUFlLENBQUM7QUFBQSxJQUNsRDtBQUFBLEVBQ0Q7QUFDRjs7RUE1S0UsT0FBTTtBQUFBLEVBQ04sT0FBQSxFQUF5QixhQUFBLFNBQUE7O0FBQ3BCLE1BQUEsYUFBQSxFQUFBLE9BQU0sMkNBQTBDO0FBQzlDLE1BQUEsYUFBQSxFQUFBLE9BQU0sZUFBYzs7O0VBbUIxQixPQUFNOzs7Ozs7OztBQXZCUixTQUFBQyxVQUFBLEdBQUFDLG1CQXNDTSxPQXRDTixZQXNDTTtBQUFBLElBbkNMQyxtQkFpQk0sT0FqQk4sWUFpQk07QUFBQSxNQWhCTEEsbUJBQWlFLFFBQWpFLFlBQWlFQyxnQkFBbkMsS0FBRSxHQUFBLHFCQUFBLENBQUEsR0FBQSxDQUFBO0FBQUEsTUFDaENDLFlBQVlDLE9BQUE7QUFBQSxNQUVMLEtBQUssTUFBQyxVQUFVLEtBQUEsTUFBTSxXQUFXLFdBQVcsSUFBSSxrQkFEdkRDLFlBSW9CLGtCQUFBO0FBQUE7UUFGbkIsUUFBTztBQUFBLFFBQ04sTUFBTSxLQUFFLEdBQUEsc0JBQUE7QUFBQSxRQUNSLFNBQU8sU0FBTztBQUFBO1FBRVQsV0FBQSxpQkFBQSxtQkFBYyx3QkFEckJBLFlBS2lDLCtCQUFBO0FBQUE7UUFIaEMsS0FBSTtBQUFBLG9CQUNLLE1BQWE7QUFBQSxxRUFBYixNQUFhLGdCQUFBO0FBQUEsUUFDZCxxQkFBcUIsTUFBbUI7QUFBQSw4RUFBbkIsTUFBbUIsc0JBQUE7QUFBQSxRQUMvQyxpQkFBZSxNQUFZO0FBQUE7TUFDN0JGLFlBRW1CLGtCQUFBO0FBQUEsUUFEbEIsUUFBTztBQUFBLFFBQ04sU0FBTyxTQUFNO0FBQUE7O0lBR1QsU0FBQSxXQUFXLFVBRGxCSixhQUFBQyxtQkFTTSxPQVROLFlBU007QUFBQSx3QkFOTEEsbUJBS2lDTSxVQUFBLE1BQUFDLFdBSmxCLFNBQVUsWUFBQSxDQUFqQixRQUFHOzRCQURYRixZQUtpQyx1QkFBQTtBQUFBLFVBSC9CLEtBQUssSUFBSTtBQUFBLFVBQ1QsT0FBTyxLQUFFLEdBQUEsaUJBQUE7QUFBQSxVQUNULGtCQUFnQixJQUFJO0FBQUEsVUFDcEIsU0FBSyxZQUFFLFNBQWUsZ0JBQUMsR0FBRztBQUFBOzs7SUFFN0JGLFlBTTRCLHNCQUFBO0FBQUEsTUFMM0IsS0FBSTtBQUFBLE1BQ0osZUFBQTtBQUFBLE1BQ0MsaUJBQWUsT0FBVztBQUFBLE1BQzFCLFFBQVEsT0FBTTtBQUFBLE1BQ2QsT0FBTyxNQUFhO0FBQUEsTUFDcEIsWUFBVSxTQUFZO0FBQUE7Ozs7In0=
